<app-service-pages [bg]="'#F6E5F1'" [faq]="faq">
  <ng-container title>Broadband Contracts</ng-container>
  <ng-container heading-top>Broadband Contracts</ng-container>
  <ng-container text-top>Let us find out if you’re overpaying on your broadband and match you to right package. By
    finding you the best deals based on your postcode, our experts will help switch, upgrade or even find acheaper price
  </ng-container>
  <ng-container img-top><img src="assets/images/broadbandtop.png" alt="Broadband Contracts" class="img-top">
  </ng-container>
  <ng-container img-bot><img src="assets/images/broadbandbot.png" alt="Broadband Contracts" class="img-bot">
  </ng-container>
  <ng-container text-bot>
    <ul>
      <li>
        Working with our trusted partner – Shell Broadband offering award winning broadband.
      </li>
      <li>
        Dedicated team of inhouse advisors – offering the best customer service and advice.
      </li>
      <li>
        A choice of packages – explained and managed to suit all household needs.
      </li>
      <li>
        Ongoing help and support from the Shell Broadband team through the term of your contact.
      </li>
    </ul>
  </ng-container>
  <ng-container button-top>
    <a [routerLink]="['/third-party-contact/e511d3db-8ce0-4f1b-b8c7-f6553581ba0b']" target="_blank"
      rel="noopener noreferrer">
      <button mat-flat-button fxShow="false" fxShow.gt-sm>
        Start Saving Today
      </button>
    </a>
  </ng-container>
  <ng-container button-bot>
    <a [routerLink]="['/third-party-contact/e511d3db-8ce0-4f1b-b8c7-f6553581ba0b']" target="_blank"
      rel="noopener noreferrer">
      <button mat-flat-button fxShow="false" fxShow.gt-sm>
        Enquire Today
      </button>
    </a>
  </ng-container>
</app-service-pages>